import { createRouter, createWebHistory } from 'vue-router';
// import Home from '../views/HomePage.vue';
import store from '../store';

const ifNotAuthenticated = (to, from, next) => {
  console.log(from.path, '-', to.path);
  if (!store.getters['users/isAuthenticated']) {
    next();
    return;
  }
  next('/');
};

const ifAuthenticated = (to, from, next) => {
  console.log(from.path, ';', to.path);
  if (store.getters['users/isAuthenticated']) {
    next();
    return;
  }

  next('/login');
};

const ifHr = (to, from, next) => {
  if (store.getters['users/isAuthenticated']) {
    const { userType } = store.getters['users/userInfo'];
    // @TODO: change to reflect only hr when needed
    if (userType === 'hr' || userType === 'admin') {
      next();
      return;
    }
    next('/');
    return;
  }
  next('/login');
};

const ifHrOperation = (to, from, next) => {
  if (store.getters['users/isAuthenticated']) {
    const { userType } = store.getters['users/userInfo'];
    const arr = ['admin', 'hr', 'operation'];
    if (arr.includes(userType)) {
      next();
      return;
    }
    next('/');
    return;
  }
  next('/login');
};
const ifOperation = (to, from, next) => {
  if (store.getters['users/isAuthenticated']) {
    const { userType } = store.getters['users/userInfo'];
    const arr = ['admin', 'operation'];
    if (arr.includes(userType)) {
      next();
      return;
    }
    next('/');
    return;
  }
  next('/login');
};

const ifNotEmployee = (to, from, next) => {
  if (store.getters['users/isAuthenticated']) {
    const { userType } = store.getters['users/userInfo'];
    if (userType !== 'employee') {
      next();
      return;
    }
    next('/');
    return;
  }
  next('/login');
};

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   // @TODO: change back to home
  //   // component: Home,
  //   component: () => import('../views/HomePage.vue'),
  //   beforeEnter: ifNotAuthenticated,
  // },
  // {
  //   path: '/contact/',
  //   name: 'Contact',
  //   component: () => import('../components/ContactUs.vue'),
  //   // component: () => import('../components/BlankPage.vue'),
  // },
  // {
  //   path: '/careers/',
  //   name: 'Careers',
  //   component: () => import('../components/AllCareers.vue'),
  //   // component: () => import('../components/BlankPage.vue'),
  // },
  // {
  //   path: '/careers/:id/',
  //   name: 'CareerDetails',
  //   component: () => import('../components/CareerDetails.vue'),
  //   // component: () => import('../components/BlankPage.vue'),
  // },
  // {
  //   path: '/blog/',
  //   name: 'Blog',
  //   component: () => import('../components/BlogIndex.vue'),
  //   // component: () => import('../components/BlankPage.vue'),
  // }, {
  //   path: '/blog/:title/',
  //   name: 'BlogDetails',
  //   component: () => import('../components/BlogDetails.vue'),
  //   // component: () => import('../components/BlankPage.vue'),
  // },
  {
    path: '/',
    name: 'App',
    component: () => import('../views/HomeApp.vue'),
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/employee',
    name: 'Employee',
    component: () => import('../components/employee/EmployeeAdmin.vue'),
    beforeEnter: ifNotEmployee,
  },
  {
    path: '/time-tracker',
    name: 'TimeTracker',
    component: () => import('../components/time-tracker/TimeTracker.vue'),
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/time-tracker/report',
    name: 'TimeTrackerReport',
    component: () => import('../components/time-tracker/DetailedReport.vue'),
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/time-tracker/kpi',
    name: 'KpiReport',
    component: () => import('../components/time-tracker/KpiReport.vue'),
    beforeEnter: ifNotEmployee,
  },
  {
    path: '/time-tracker/aht',
    name: 'AhtReport',
    component: () => import('../components/time-tracker/AhtReport.vue'),
    beforeEnter: ifNotEmployee,
  },
  {
    path: '/time-tracker/week-monitor',
    name: 'WeekMonitor',
    component: () => import('../components/time-tracker/WeekMonitor.vue'),
    beforeEnter: ifNotEmployee,
  },
  {
    path: '/time-tracker/report-summary',
    name: 'TimeTrackerReportSummary',
    component: () => import('../components/time-tracker/SummarizedReport.vue'),
    beforeEnter: ifNotEmployee,
  },
  {
    path: '/time-tracker/monitor',
    name: 'Monitor',
    component: () => import('../components/time-tracker/EmployeeMonitor.vue'),
    beforeEnter: ifNotEmployee,
  },
  {
    path: '/profile',
    name: 'EmployeeProfile',
    component: () => import('../components/employee/Profile.vue'),
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/employee/:id',
    name: 'EmployeeDetails',
    component: () => import('../components/employee/EmployeeDetails.vue'),
    beforeEnter: ifNotEmployee,
  },
  {
    path: '/employee/add',
    name: 'EmployeeInfo',
    component: () => import('../components/employee/EmployeeForm.vue'),
    props: { empId: 0, editable: true },
    beforeEnter: ifNotEmployee,
  },
  {
    path: '/teams-admin',
    name: 'TeamsAdmin',
    component: () => import('../components/employee/TeamsAdmin.vue'),
    beforeEnter: ifOperation,
  },
  {
    path: '/tasks-admin',
    name: 'TasksAdmin',
    component: () => import('../components/time-tracker/TasksAdmin.vue'),
    beforeEnter: ifOperation,
  },
  {
    path: '/teams-view',
    name: 'TeamsView',
    component: () => import('../components/employee/TeamsView.vue'),
    beforeEnter: ifHrOperation,
  },
  {
    path: '/application',
    name: 'Application',
    component: () => import('../components/application/ApplicationAdmin.vue'),
    beforeEnter: ifHrOperation,
  },
  {
    path: '/application/edit/:id',
    name: 'ApplicationDetails',
    component: () => import('../components/application/ApplicationDetails.vue'),
    beforeEnter: ifHr,
  },
  // {
  //   path: '/apply/',
  //   name: 'Apply',
  //   component: () => import('../components/application/ApplicationForm.vue'),
  // },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../auth/Login.vue'),
    // beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/forgot-password',
    name: 'Reset',
    component: () => import(/* webpackChunkName: "login" */ '../auth/ForgotPassword.vue'),
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/auth/password/reset/confirm/:uid/:token',
    name: 'ResetConfirm',
    component: () => import('../auth/ActivateReset.vue'),
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('../auth/ChangePassword.vue'),
    beforeEnter: ifAuthenticated,
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import(/* webpackChunkName: "login" */ '../auth/SignUp.vue'),
  //   beforeEnter: ifNotAuthenticated,
  // },
  {
    path: '/change-password',
    name: 'Change password',
    component: () => import('../auth/ActivateReset.vue'),
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../components/BlankPage.vue'),
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../components/BlankPage.vue'),
  },
  {
    path: '/attendance',
    name: 'Attendance',
    component: () => import('../components/time-tracker/Attendance.vue'),
    // beforeEnter: ifOperation,
  },
  {
    path: '/time-tracker/quality-kpi',
    name: 'EmployeeQuality',
    component: () => import('../components/time-tracker/QualityKpi.vue'),
    beforeEnter: ifAuthenticated,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
